import { FadeUp, PageHero } from "../components/Reveal";
import { IMG } from "../lib/content";

const METALS = [
  { name: "9ct Gold", mark: "375", variants: ["Yellow gold", "Rose gold", "White gold"] },
  { name: "18ct Gold", mark: "750", variants: ["Yellow gold", "White gold"] },
  { name: "Platinum", mark: "950", variants: ["A high-quality precious metal known for durability and its distinctive finish"] },
  { name: "Sterling Silver", mark: "925", variants: ["Classic sterling silver used across a range of jewellery designs"] },
  { name: "22ct Yellow Gold", mark: "Repairs", variants: ["We can also work with 22ct yellow gold for repair services"] },
];

export default function Metals() {
  return (
    <main data-testid="metals-page">
      <PageHero
        eyebrow="Metal Information"
        title="The metals we work with"
        sub="A guide to the precious metals used in Celtic Gold jewellery."
        image={IMG.rings}
      />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {METALS.map((m, i) => (
            <FadeUp key={m.name} delay={(i % 2) * 0.08}>
              <div className="border border-white/5 hover:border-gold/40 transition-colors duration-500 bg-ink-2/40 p-8 h-full" data-testid={`metal-${m.name.toLowerCase().replace(/\s+/g, "-")}`}>
                <p className="font-mono text-xs text-gold tracking-[0.3em] mb-3">{m.mark}</p>
                <h2 className="font-serif text-2xl text-ivory font-light mb-4">{m.name}</h2>
                <ul className="space-y-2">
                  {m.variants.map((v) => (
                    <li key={v} className="text-stone-mist text-sm font-light flex items-center gap-3">
                      <span className="w-1 h-1 bg-gold rotate-45 shrink-0" /> {v}
                    </li>
                  ))}
                </ul>
              </div>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mt-12">
          <div className="border border-gold/30 bg-gold/5 p-8 text-center" data-testid="metals-quality-note">
            <p className="font-serif text-xl sm:text-2xl text-ivory font-light leading-relaxed max-w-3xl mx-auto">
              Celtic Gold does not supply hollow or poor-quality jewellery. Pieces are crafted with a focus on
              quality, workmanship and longevity.
            </p>
          </div>
        </FadeUp>
      </section>
    </main>
  );
}
